export const RISK_PROFILE_OPTIONS = [
	{ label: 'Conservative', value: 'conservative' },
	{ label: 'Moderately Conservative', value: 'moderately-conservative' },
	{ label: 'Moderate', value: 'moderate' },
	{ label: 'Moderately Aggressive', value: 'moderately-aggressive' },
	{ label: 'Aggressive', value: 'aggressive' },
];

export const TIME_HORIZON_OPTIONS = [
	{ label: '1-5 years', value: '1-5-years' },
	{ label: '5-10 years', value: '5-10-years' },
	{ label: '10-20 years', value: '10-20-years' },
	{ label: '20+ years', value: '20-plus-years' },
];

export const TAX_CONSIDERATION_DEFAULT_COPY =
	'Generally not a major factor but should be reviewed annually.';

export const TAX_EXEMPTIONS_DEFAULT_COPY =
	'Not prioritized unless it is advantageous to long-term goals.';

export const LIQUIDITY_REQUIREMENTS_DETAILS_DEFAULT_COPY =
	'There are no immediate liquidity events anticipated within the stated period.';

export const IPS_DATE_FORMAT = 'MM-DD-YYYY';
